// extracted by mini-css-extract-plugin
export default {"companyContainer":"bO-z","companyImage":"cO-z","container":"dO-z","heading":"eO-z","darkText":"fO-z","smallHeading":"gO-z","darkBackground":"hO-z","whiteBackground":"iO-z"};